/** Visual break between prior thread messages and ephemeral pending greetings. */
export function GreetingSeparator() {
  return (
    <div
      className="teo-greeting-separator"
      role="separator"
      aria-hidden="true"
    />
  );
}
